import { gql } from '@apollo/client';

export const GET_DOCUMENTS_V2 = gql`
  query GetDocumentsV2(
    $options: GetDocumentsQueryInputOptions!
    $query: GetDocumentsQueryInput!
  ) {
    getDocumentsV2(options: $options, query: $query) {
      count
      documents {
        id
        type
        contentType
        key
        bucket
        name
        status
        createdAt
        foreignKeys
        signatory
        groupIds
        firstName
        lastName
      }
    }
  }
`;

export const GET_DOCUMENTS = gql`
  query GetDocuments(
    $options: GetDocumentsQueryInputOptions!
    $query: GetDocumentsQueryInput!
  ) {
    getDocuments(options: $options, query: $query) {
      count
      documents {
        id
        type
        contentType
        key
        bucket
        name
        status
        createdAt
        foreignKeys
        signatory
        errorMessage
      }
    }
  }
`;

export const GET_UNIQUE_LATEST_DOCUMENTS_V2 = gql`
  query GetUniqueLatestDocumentsV2($query: GetUniqueLatestDocumentsQueryInput!) {
    getUniqueLatestDocumentsV2(query: $query) {
      documents {
        id
        type
        contentType
        key
        bucket
        name
        status
        createdAt
        foreignKeys
        signatory
        groupIds
      }
    }
  }
`;

export const GET_UNIQUE_LATEST_DOCUMENTS = gql`
  query GetUniqueLatestDocuments(
    $query: GetUniqueLatestDocumentsQueryInput!
  ) {
    getUniqueLatestDocuments(query: $query) {
      documents {
        id
        type
        contentType
        key
        bucket
        name
        status
        createdAt
        foreignKeys
        signatory
      }
    }
  }
`;

export const GET_SIGNED_URLS = gql`
  query GetSignedUrls($query: GetSignedUrlsQueryInput!) {
    getSignedUrls(query: $query) {
      signedUrls {
        id
        signedUrl
      }
    }
  }
`;

export const GET_SIGNED_URL = gql`
  query GetSignedUrl($query: GetSignedUrlQueryInput!) {
    getSignedUrl(query: $query) {
      signedUrl
    }
  }
`;

export const GET_DOCUMENT_METADATA = gql`
  query GetDocumentMetadata($query: GetDocumentMetadataInput!) {
    getDocumentMetadata(query: $query) {
      data {
        documentId
        metadataType
        metadata
        show
      }
    }
  }
`;

export const GET_DOCUMENT_LINKS = gql`
  query DocumentLinks(
    $options: GetDocumentLinksQueryInputOptions!
    $query: GetDocumentLinksQueryInput!
  ) {
    getDocumentLinks(options: $options, query: $query) {
      documentLinks {
        id
        createdAt
        updatedAt
        type
        link
        name
        uploadedBy
        foreignKeys
      }
      count
    }
  }
`;

export const GET_DOCUMENT_TYPES = gql`
  query GetAvailableDocumentTypes($query: AvailableDocumentTypesInput!) {
    getAvailableDocumentTypes(query: $query) {
      id
      createdAt
      updatedAt
      type
      name
      localizationSlug
      canView
      canUpload
      canDelete
    }
  }
`;
